import { Component } from '@angular/core';
import { LoginControl } from 'app/_services/logincontrol.service';
import { Subscription } from 'rxjs';
import { LogService } from 'app/_services/logmanager.service';
import { Router } from '@angular/router';
import { DataService } from 'app/_services/datamanager.service';
import { AlertService } from 'app/_services/alert.service';
import { GlobalsService } from 'app/_services/globals.service';
import { LoginAs } from 'app/_services/loginAs.service';

@Component({
    selector: 'sec-header',
    templateUrl: './header.component.html',
    styles: ['a { color: #55b7da; } a:hover { color: #009cda; } .logoutlink a:hover { color: #d6162f !important }'],
    providers: [LoginAs]
})

export class HeaderComponent {
    errorMessage: string;
    subscription: Subscription;
    infoactualizada = false;
    testEnvironment = false;
    preEnvironment = false;
    picture = false;
    secretaria = '';
    dir = '';
    desconnectar = '';
    nomUsuari = '';
    imagedir = '';
    realUsername = '';

    constructor(
        private dataService: DataService,
        private loginControl: LoginControl,
        private alertService: AlertService,
        private router: Router,
        private loginAs: LoginAs,
        private globalStorage: GlobalsService
    ) {
        this.checkinfo(); // si se recarga la página la info ya estará
        this.subscription = loginControl.checkedsession.subscribe(
          checkedsession => {
            if (checkedsession) {
                this.checkinfo();
                this.getUserPicture();
            }
        });

        router.events.subscribe(() => {
            this.checkinfo();
        });
    }

    checkinfo(debug = false) {
        this.infoactualizada = false;
        const currentuserjson = this.globalStorage.getItem('currentUser');
        LogService.log('HeaderComponent', 'checkinfo', debug);
        LogService.log('HeaderComponent', this.imagedir, debug);
        this.imagedir = this.globalStorage.getItem('imagedir');
        this.desconnectar = this.globalStorage.getItem('campusdir');

        if (currentuserjson) {
            LogService.log('HeaderComponent', currentuserjson, debug);

            const currentuser = JSON.parse(currentuserjson);
            this.realUsername = currentuser.real_username;
            if (currentuser.nom) {
                this.nomUsuari = currentuser.nom + ' ' + currentuser.cognom1;
                if (currentuser.cognom2 !== null) {
                    this.nomUsuari = this.nomUsuari + ' ' + currentuser.cognom2;
                }
                this.infoactualizada = true;
            }
            LogService.log('HeaderComponent', 'Environment: ' + currentuser.environment, debug);

            switch (currentuser.environment) {
                case 0:
                case false:
                    this.testEnvironment = true;
                    break;
                case 1:
                    this.preEnvironment = true;
                    break;
                case 2:
                    break;
            }

            this.secretaria = this.globalStorage.getItem('secretariaName');
            LogService.log('HeaderComponent', 'IsTest: ' + this.testEnvironment + ' / IsPre: ' + this.preEnvironment, debug);
        }
        if (!this.infoactualizada) {
            LogService.log('HeaderComponent', 'HeaderComponent -> checkinfo -> esperando info de usuario...', debug);
        }
    }

    getUserPicture() {
        // const params = <any>{
        //     'accio': 'WsGetOwnPicture'
        // };
        // this.dataService.getData(params).subscribe(
        //     data => {
        //         LogService.log('HeaderComponent', 'Own picture returned.');
        //         this.picture = data[0];
        //     },
        //     error => {
        //         this.errorMessage = <any>error;
        //         this.alertService.error(this.errorMessage);
        //     }
        // );
    }

    logout() {
        const params = <any>{
            'accio': 'WsLogout'
        };

        this.dataService.getData(params).subscribe(
            data => {
                LogService.log('HeaderComponent', data);
                this.globalStorage.clear().then( () => {
                    window.location.href = this.desconnectar;
                });
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    /**
     * @Carlos y @nacho: Permite realizar el cambio de secretaria
     */
    changeSecretaria() {
        LogService.log('HeaderComponent', 'Canvi de secretaria');

        this.globalStorage.removeItems([
            'searchUser',
            'searchUserlastUpdate',
            'secretaria',
            'secretariaName'
        ]).then(() => {
            window.location.href = 'welcome';
        });
    }
}

